import { render } from "./DigiQHome.vue?vue&type=template&id=1552d932"
import script from "./DigiQHome.vue?vue&type=script&lang=js"
export * from "./DigiQHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__